import EditableJsonTree from "./JsonEditor";
import React, { useEffect, useRef, useState } from "react";
import { linearize, getObjectDifference } from "./Update";
import useAxios from "../hooks/useAxios";
import { ChromePicker } from "react-color";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  InputNumber,
  Checkbox,
  DatePicker,
} from "antd";

import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { PEButton } from "./permissionComponents/index";
import moment from "moment";

const _ = require("lodash");


const { Option } = Select;

const defaultConfig = {
  fieldname: "",
  isEdit: "0",
  isRequired: "0",
  isRequiredFormview: "0",
  isVisible: "1",
  onlyVisibleInFormview: "0",
  isClickable: "0",
  defaultfilter: "",
  addapi: "0",
  datatype: null,
  tablesource: "",
  showLabel: "1",
  dropdownlist: "",
  Downloadfile: "",
  isSearch: "0",
  productlist: "",
  productid: "",
  massupdate: "0",
  isConfirm: "0",
  isEditDisable: "0",
  DisableOnFieldValue: "",
  isRedirect: "0",
  FileType: "",
  FileSize: "",
  FilePath: "",
  FileName: "",
  otherFieldName: "",
  arithmeticOperation: "",
  arithmeticOperator: "",
  operationValue: null,
};

export default function FieldMappingEditor({
  referenceJson,
  field_mapping,
  onChange,
  apidata,
  viewlist,
  dropdowndata,
  view_type,
  filteredservice_id,
  validDate,
  setvalidDateCondition,
  setParentFieldCount,
  parentFieldCount,
}) {

  const [data, setData] = useState({});
  const [blockFieldMappings, setBlockFieldMappings] = useState({});
  const [leafFieldMappings, setLeafFieldMappings] = useState([]);
  const [fieldlist, setFieldlist] = useState([]);
  const [baseJson, setbaseJson] = useState([]);

  useEffect(() => {
    
    field_mapping.forEach((obj, index) => {
      obj["globalMappingSequence"] = index + 1;
    });
    // filter block and jsonData types
    let _blockFieldMappings = field_mapping.filter((mapping) => {
      return (
        mapping["datatype"] === "block" || mapping["datatype"] === "jsondata"
        // mapping["datatype"] === "hyperlink"
      );
    });

    // removing field_mappings with block Configs
    const leaf_field_mapping = field_mapping.filter((mapping) => {
      // return true
      return !(
        (mapping["datatype"] === "block" || mapping["datatype"] === "jsondata")
        // mapping["datatype"] === "hyperlink"
      );
    });
    setLeafFieldMappings(leaf_field_mapping);

    // create nested object with configs as values
    const nestedConfig = createNestedJson(leaf_field_mapping);
    setbaseJson(referenceJson);
    // initialize leaf nodes as empty objects for reference Json
    setLeafNodes(referenceJson, "[]");

    // merge the existing configs with referenceJson
    const mergedObj = _.mergeWith(referenceJson, nestedConfig);
    // to set the data type of the configs to object, once nested fields are found.
    try {
      _blockFieldMappings.forEach((mapping) => {
        const path = getObjectPath(mapping["BucketField"]);
        let currentLevel = mergedObj;
        for (let i = 0; i < path.length; i++) {
          if (i == path.length - 1) {
            if (currentLevel[path[i]]) {
              continue;
            } else {
              currentLevel[path[i]] = {};
              break;
            }
          } else {
            currentLevel = currentLevel[path[i]];
          }
        }
      });

      _blockFieldMappings = _blockFieldMappings.reduce((obj, value) => {
        if (!obj[value["BucketField"]]) {
          obj[value["BucketField"]] = [];
        }
        obj[value["BucketField"]].push(value);
        return obj;
      }, {});

      setData(mergedObj);
      setBlockFieldMappings({ ..._blockFieldMappings });
      setFieldlist(field_mapping);
      console.log("field_mapping", fieldlist);
    } catch (e) {
      console.log(e);
    }
  }, [referenceJson, field_mapping]);

  // onChange event to return the linearized field mapping
  const createFieldMapping = (value) => {
    const linearConfig = linearize(value);
    const fieldMapping = Object.keys(linearConfig).reduce((obj, key) => {
      const configs = JSON.parse(linearConfig[key]);
      configs.length > 0 && configs.forEach((config) => {
        obj.push({
          ...config,
          BucketField: key,
        });
      });

      return obj;
    }, []);
    return fieldMapping;
  };

  const onChangeWithSequence = (new_field_mapping) => {
    let attributeName = "globalMappingSequence";
    let timestampAttributeName = "mappingSequenceTimestamp";

    new_field_mapping.sort((a, b) => {
      if (a[attributeName] !== b[attributeName]) {
        return a[attributeName] - b[attributeName];
      } else {
        const timestampA = a[timestampAttributeName] || 0;
        const timestampB = b[timestampAttributeName] || 0;
        return timestampB - timestampA;
      }
    });

    new_field_mapping = new_field_mapping.reduce((acc, obj) => {
      const {
        [timestampAttributeName]: timestamp,
        [attributeName]: mappingSequence,
        ...rest
      } = obj;
      acc.push(rest);
      return acc;
    }, []);

    onChange(new_field_mapping);
  };

  const onChangeHandler = (value) => {
    const _fieldlist = createFieldMapping(value);
    setLeafFieldMappings(_fieldlist);
    const new_field_mapping = createNewFieldMapping(
      _fieldlist,
      blockFieldMappings
    );
    setFieldlist(new_field_mapping);
    onChangeWithSequence(new_field_mapping);
  };

  // handler to save the config of block types
  const saveBlockConfig = (path, values) => {
    const bucketFieldString = getBucketFieldString(path);
    blockFieldMappings[bucketFieldString] = values;
    const new_field_mapping = createNewFieldMapping(
      leafFieldMappings,
      blockFieldMappings
    );
    setFieldlist(new_field_mapping);
    onChangeWithSequence(new_field_mapping);
  };

  const createNewFieldMapping = (fieldMappings, blockFieldMappings) => {
    // console.log(fieldMappings, blockFieldMappings);
    const new_field_mappings = [...fieldMappings];
    Object.keys(blockFieldMappings).forEach((bucketField) => {
      new_field_mappings.push(...blockFieldMappings[bucketField]);
    });
    return new_field_mappings;
  };

  // Handler to show only assigned fields and unassigned fields and all fields.
  const handleFilterSelect = (values) => { };

  // ValueRenderer for field mapping
  const filterOptions = [
    { option: "All fields", value: 0 },
    { option: "Mapped fields", value: 1 },
  ];

  return (
    <div className="view_field_mapping_editor">
      {/* <div className="d-flex justify-content-between pl-2">
            <div></div>
            <Select style={{width:'150px'}} onChange={handleFilterSelect} defaultValue={0}>
                {
                    filterOptions.map(({option,value}) => (
                        <Option key={option} value={value}>
                            {option}
                        </Option>
                    ))
                }
            </Select>
            
        </div> */}
      <EditableJsonTree
        editEnabled={true}
        data={data}
        onChange={onChangeHandler}
        validDate={validDate}
        setParentFieldCount={setParentFieldCount}
        parentFieldCount={parentFieldCount}
        setvalidDateCondition={setvalidDateCondition}        
        ValueRenderer={({ path, jsonConfig, onFormSubmit, valueType }) => {
          return (
            <ConfigFormRenderer
              path={path}
              jsonConfig={jsonConfig}
              onFormSubmit={onFormSubmit}
              apidata={apidata}
              fieldlist={fieldlist}
              valueType={valueType}
              dropdownlist={dropdowndata}
              viewlist={viewlist}
              view_type={view_type}
              referenceJson={referenceJson}
              filteredservice_id={filteredservice_id}
              validDate={validDate}
              setvalidDateCondition={setvalidDateCondition}
              setParentFieldCount = {setParentFieldCount}
              parentFieldCount={parentFieldCount}
              baseJson={baseJson}
            />
          );
        }}
        NestedValueRenderer={({ path, valueType, value, itemString, itemType }) => {
          const bucketFieldString = getBucketFieldString(path);

          const jsonConfig = JSON.stringify(
            blockFieldMappings[bucketFieldString]
              ? blockFieldMappings[bucketFieldString]
              : []
          );

          return (
            <ConfigFormRenderer
              path={path}
              jsonConfig={jsonConfig}
              onFormSubmit={saveBlockConfig}
              apidata={apidata}
              fieldlist={fieldlist}
              valueType={valueType}
              dropdownlist={dropdowndata}
              viewlist={viewlist}
              itemType={itemType}
              view_type={view_type}
              referenceJson={referenceJson}
              filteredservice_id={filteredservice_id}
              validDate={validDate}
              setvalidDateCondition={setvalidDateCondition} 
              setParentFieldCount={setParentFieldCount}
              parentFieldCount={parentFieldCount}
              baseJson={baseJson}
            />
          );
        }}
        addFrom={"createview"}
      />
    </div>
  );
}

const ConfigFormRenderer = ({
  path,
  jsonConfig,
  onFormSubmit,
  apidata,
  valueType,
  fieldlist,
  dropdownlist,
  viewlist,
  itemType,
  view_type,
  referenceJson,
  filteredservice_id,
  validDate,
  setvalidDateCondition,
  setParentFieldCount,
  parentFieldCount,
  baseJson,
}) => {
  const [loading, sendRequest] = useAxios();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [configs, setConfigs] = useState(JSON.parse(jsonConfig));
  const [dropdownResponse, setdropdownResponse] = useState();
  const [dropdownResponsebasedata, setdropdownResponsebasedata] = useState();
  const [allRules, setallRules] = useState([]);
  const [fieldCount, setFieldCount] = useState(0);
  const [fieldSets, setFieldSets] = useState([]);

  useEffect(() => {
    const _configs = jsonConfig ? JSON.parse(jsonConfig) : [];
    if(_configs.length > 0 ){
      _configs.forEach((config, index) => {
        config["index"] = index;
      });
      setConfigs(_configs);
    }
  }, [jsonConfig]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setConfigs(JSON.parse(jsonConfig));
    setIsModalVisible(false);
  };

  
  const transformConfigToDateCondition = (config) => {
    const dateCondition = Object.keys(config)
      .filter((key) => key.startsWith("operator-") || key.startsWith("day-") || key.startsWith("color-"))
      .reduce((acc, key) => {
        const [type, id] = key.split("-");
        if (!acc[id]) acc[id] = {};
        acc[id][type] = config[key];
        return acc;
      }, {});

    return Object.values(dateCondition);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    const updatedConfigs = configs.map((config, configIndex) => {
      if (config.datatype === "date") {
        // Extract date condition fields from config
        const dateConditionFromConfig = Object.keys(config)
          .filter((key) => key.startsWith("operator-") || key.startsWith("day-") || key.startsWith("color-"))
          .reduce((acc, key) => {
            const [type, id] = key.split("-");
            if (!acc[id]) acc[id] = { id: parseInt(id) }; // Ensure `id` is included
            acc[id][type] = config[key];
            return acc;
          }, {});
    
        // Convert to array of date condition objects
        const dateConditionArray = Object.values(dateConditionFromConfig);
    
        // Merge with fieldSets (if any)
        const fieldSetForConfig = fieldSets.filter(
          (fieldSet) => fieldSet.configIndex === configIndex
        );
    
        const mergedDateCondition = [
          ...dateConditionArray,
          ...fieldSetForConfig.map((fieldSet) => ({
            id: fieldSet.id,
            operator: fieldSet.operator,
            day: fieldSet.day,
            color: fieldSet.color,
          })),
        ];
    
        // Remove duplicates based on `id`
        const uniqueDateCondition = mergedDateCondition.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
    
        return {
          ...config,
          datecondition: Object.values(uniqueDateCondition), // Ensure unique `datecondition` objects
        };
      }
      return config;
    });

    // Apply the transformation to the configs before submitting
    let transformedConfigs = updatedConfigs.map((config) => {
      const transformedDateCondition = transformConfigToDateCondition(config);
      return {
        ...config,
        datecondition: config.datecondition || [], // Add transformed datecondition to config
      };
    });

    transformedConfigs = transformedConfigs.map((config) => {
      if (config.datatype === "date") {
        const validIds = fieldSets.map((fieldSet) => fieldSet.id); // Get all valid IDs from fieldSets
    
        // Create a temp array with filtered datecondition objects
        const temp = config.datecondition.filter((condition) =>
          validIds.includes(condition.id) // Keep only conditions with IDs present in fieldSets
        );
    
        return {
          ...config,
          datecondition: temp, // Update datecondition with the temp array
        };
      }
      return config;
    });

    onFormSubmit(
      path,
      transformedConfigs.reduce((obj, config) => {
        const { index: index, ...rest } = config;
        obj.push({ BucketField: getBucketFieldString(path), ...rest });
        return obj;
      }, [])
    );
    const bucket_field_name = (JSON.parse(jsonConfig))[0].BucketField;
    const isValid = fieldlist.some(
      (field) =>
        field.datatype === "date" &&
        Array.isArray(field.datecondition) &&
        field.datecondition.length > 0 &&
        field.BucketField !== bucket_field_name
    );
    if(fieldCount === 0){
      if(!isValid){
        setvalidDateCondition(()=>false)
      }      
    }
    if(fieldCount > 0){
      setParentFieldCount(()=>1);
    }
    setIsModalVisible(false);
  };

  // const handleSave = (e) => {
  //   e.stopPropagation();

  //   onFormSubmit(
  //     path,
  //     configs.reduce((obj, config) => {
  //       const {index:index,...rest} = config;
  //       obj.push({ BucketField: getBucketFieldString(path), ...rest});
  //       return obj;
  //     }, [])
  //   );
  //   setIsModalVisible(false);
  // };

  const fieldNames = configs.length > 0 ? configs.reduce((obj, config) => {
    obj.push(config["fieldname"]);
    return obj;
  }, [])
  :[];

  // getBucketFieldString

  const updateConfig = (config, index) => {
    const _configs = [...configs];
    config["index"] = index;
    _configs.splice(index, 1, config);
    setConfigs(_configs);
  };

  const deleteConfig = (index) => {
    const _configs = [...configs];
    _configs.splice(index, 1);
    console.log("_configs",_configs);
    setConfigs(_configs);
  };

  const handleAddField = () => {
    let _configs;
    if(configs.length){
      _configs = [...configs];
    } else {
      _configs = [];
    }    
    console.log(_configs);
    defaultConfig["index"] = _configs.length;
    _configs.push(defaultConfig);
    setConfigs(_configs);
  };
  useEffect(() => {
    const uniqueItems = dropdownResponsebasedata && dropdownResponsebasedata.filter((item, index, self) => {
      // Check if this item_value is unique in the array
      return self.findIndex(i => i.item_value === item.item_value) === index;
    });
    setdropdownResponse(uniqueItems);
  }, [dropdownResponsebasedata]);
  const filteroutput = (dropdownlistid) => {
    let apitoken = localStorage.getItem("api_token");

    // Ensure dropdownlistid is processed as an array
    const dropdownIds = Array.isArray(dropdownlistid) ? dropdownlistid : [dropdownlistid];

    dropdownIds.forEach((id) => {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/dropdown/item/list?dropdown_id=${id}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("dropdownlist", response);
          setdropdownResponsebasedata((prev) => [...(prev || []), ...response]); // Handle non-filtered data          
        }
      );
    });

    if (fieldlist[0].search_query) {
      const allRules = extractAllRules(fieldlist[0].search_query.rules);
      const groupedData = Object.values(groupData(allRules));
      console.log("ConfigFormRenderer", groupedData);
      setallRules(groupedData);
    }
  };

  const groupData = (data) => {
    return data.reduce((acc, item) => {
      const field = item.field;
      if (!acc[field]) {
        acc[field] = { field, values: [] };
      }
      acc[field].values.push(item.value);
      return acc;
    }, {});
  };
  return (
    <>
      <div
        style={{ display: "inline" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <span onClick={showModal} style={{ cursor: "pointer" }}>
          [{" "}
          {configs.length > 0 && configs.map((config, index) => {
            return (
              <span key={config["fieldname"]}>
                {config["fieldname"]}
                <span style={{ color: "grey" }}>
                  {" "}
                  ({config["globalMappingSequence"]})
                </span>
                {configs.length - 1 != index ? ", " : ""}
              </span>
            );
          })}{" "}
          ]
        </span>
        <Modal
          title="Fields"
          open={isModalVisible}
          onCancel={handleCancel}
          width={"100%"}
          height={"80%"}
          footer={null}
        >
          {configs.length > 0 && configs.map((c, index) => {
            return (
              <div className="view_field_form_container" key={c.index}>
                <FieldMappingForm
                  config={c}
                  fieldlist={fieldlist}
                  apidata={apidata}
                  dropdownlist={dropdownlist}
                  viewlist={viewlist}
                  setConfig={(newConfig) => {
                    updateConfig(newConfig, index);
                  }}
                  deleteConfig={() => {
                    deleteConfig(index);
                  }}
                  filteroutput={(e) => {
                    filteroutput(e);
                  }}
                  valueType={valueType}
                  path={path}
                  dropdownResponse={dropdownResponse}
                  allRules={allRules}
                  view_type={view_type}
                  referenceJson={referenceJson}
                  validDate={validDate}
                  setvalidDateCondition={setvalidDateCondition}
                  setParentFieldCount={setParentFieldCount}
                  parentFieldCount={parentFieldCount}
                  fieldCount={fieldCount} 
                  setFieldCount={setFieldCount}
                  fieldSets={fieldSets}
                  setFieldSets={setFieldSets}
                  baseJson={baseJson}
              />
              </div>
            );
          })}
          <Row justify="center" align="middle" gutter={8}>
            <Col>
              <PEButton
                element_id="createview_newfield"
                className="add_view_field_button"
                onClick={handleAddField}
                type="primary"
              >
                New Field <PlusOutlined />
              </PEButton>
            </Col>
            <Col>
              <PEButton
                element_id="createview_save"
                className="add_view_field_button"
                onClick={handleSave}
                type="primary"
              >
                Save
              </PEButton>
            </Col>
          </Row>
        </Modal>
      </div>
    </>
  );
};
const extractAllRules = (rules) => {
  let result = [];

  rules.forEach((rule) => {
    if (rule.rules) {
      // Recursively handle nested rules
      result = result.concat(extractAllRules(rule.rules));
    } else {
      result.push({
        field: rule.field,
        operator: rule.operator,
        value: rule.value,
      });
    }
  });

  return result;
};
const FieldMappingForm = ({
  config,
  setConfig,
  deleteConfig,
  filteroutput,
  fieldlist,
  apidata,
  dropdownlist,
  viewlist,
  valueType,
  path,
  dropdownResponse,
  allRules,
  view_type,
  referenceJson,
  validDate,
  setvalidDateCondition,
  fieldCount, 
  setFieldCount,
  fieldSets,
  setFieldSets,
  setParentFieldCount,
  parentFieldCount,
  baseJson,
}) => {
  const [form] = Form.useForm();
  config = { 
    ...defaultConfig, 
    ...config, 
    alert_condition: (config && config.alert_condition) || (defaultConfig && defaultConfig.alert_condition) || [] 
  };
  const [editDisableConfig, setEditDisableConfig] = useState(
    config.isEditDisable
  );
  const [loading, sendRequest] = useAxios();
  const [addApiConfig, setAddApiConfig] = useState(config.addapi);
  const [datatypeConfig, setDatatypeConfig] = useState(config.datatype || "");
  const [redirectConfig, setRedirectConfig] = useState(config.isRedirect);
  const [extraFieldInForm, setExtraFieldInForm] = useState(config.extraFieldInForm);
  const [payloadPathInSelectedForm, setPayloadPathInSelectedForm] = useState(config.payloadPathInSelectedForm || [{ id: Date.now(), payloadpath: "", viewId: "" }]);
  const [selectData, setSelectData] = useState(config.selectData);
  const [selectionType, setSelectionType] = useState(config.selectionType);
  const [colorbtn, setcolorbtn] = useState(false);
  const [colorPickers, setColorPickers] = useState({}); // Initialize colorPickers state
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [document_group, setdocument_group] = useState([]);
  const [document_type, setdocument_type] = useState([]);
  const [fileupload, setfileupload] = useState([
    {
      selectType: "",
      UploadType: "",
      UploadSize: "",
      UploadPath: "",
      UploadName: "",
      UploadRequired: "0",
      UploadIsMultiple: "0",
      UploadRetention: "",
    },
  ]);
  const [payloadPathData, setpayloadPathData] = useState();
  const [payloadPathpopupConfig, setpayloadPathpopupConfig] = useState();
  const [showConfigDropdown, setShowConfigDropdown] = useState(false);
  const [showDateTimeFormatDropdown, setShowDateTimeFormatDropdown] = useState(false);
  const [showTextField, setShowTextField] = useState(false);
  const [beforeApiCallCheck, setBeforeApiCallCheck] = useState([]);
  const [otherField, setOtherField] = useState(config.otherField);
  const [blockTable, setblockTable] = useState([]);
  
  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/fetch/all/upload/document/type`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("document_group", response.response);
        setdocument_group(response.response);
      }
    );
    if (!config.fileupload) {
      console.log("config.fileupload not found");

      //setConfig((prevConfig) => ({ ...prevConfig, fileupload: [] }));
      setConfig({ ...config, fileupload: [] });
    }
  }, []);
  // useEffect(() => {
  //   // Update config's fileupload whenever fileupload changes
  //   setConfig((prevConfig) => ({ ...prevConfig, fileupload }));
  // }, [fileupload]);
  const getdoctype = (e) => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/fetch/upload/document/type/by/id?upload_document_type_group_id=${e}`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("document_type", response.response);
        setdocument_type(response.response);
      }
    );
  };

  const handleAdd = () => {
    console.log("handleAdd_config--", config);
    const newItem = {
      selectType: "",
      UploadType: "",
      UploadSize: "",
      UploadPath: "",
      UploadName: "",
      UploadRequired: "0",
      UploadIsMultiple: "0",
      UploadRetention: "",
    };
    // setConfig((prevConfig) => ({
    //   ...prevConfig,
    //   fileupload: [...(prevConfig.fileupload || []), newItem],
    // }));
    setConfig({
      ...config,
      fileupload: [...(config.fileupload || []), newItem], // Append newItem to fileupload
    });
  };

  const handleRemove = (index) => {
    const newfileupload = [...(config.fileupload || [])];
    newfileupload.splice(index, 1);

    // setConfig((prevConfig) => ({
    //   ...prevConfig,
    //   fileupload: newfileupload,
    // }));
    setConfig({ ...config, fileupload: newfileupload });
  };

  const handleInputChange = (value, index, field) => {
    const newfileupload = JSON.parse(JSON.stringify(config.fileupload || []));
    newfileupload[index][field] = value;

    // setConfig((prevConfig) => ({
    //   ...prevConfig,
    //   fileupload: newfileupload,
    // }));
    setConfig({ ...config, fileupload: newfileupload });
  };

  const yesnoOptions = [
    { option: "Yes", value: "1" },
    { option: "No", value: "0" },
  ];
  const mathOperatorOptions = [
    { option: "+", value: "+" },
    { option: "-", value: "-" },
    { option: "*", value: "*" },
    { option: "/", value: "/" },
    { option: "%", value: "%" },
    { option: "**", value: "**" },
    { option: "==", value: "==" },
    { option: "!=", value: "!=" },
    { option: ">", value: ">" },
    { option: "<", value: "<" },
    { option: ">=", value: ">=" },
    { option: "<=", value: "<=" },
  ];

  const syncAsyncOptions = [
    { option: "Sync", value: "sync" },
    { option: "Async", value: "async" },
  ];
  const configOptions = [
    { option: "Transaction No", value: "transaction_no" },
    // { option: "Reference No", value: "reference_no" },
    { option: "User ID", value: "user_id" },
    { option: "Date & Time", value: "date_time" },
    { option: "Random", value: "random" },
    { option: "Reusable", value: "reusable" },    
  ];
  const dateTimeFormats = [
    { option: "ISO", value: "iso" },
    { option: "US", value: "us" },
    { option: "European/International", value: "intl" },
    { option: "Unix Epoch", value: "unix" },
    { option: "RFC 2822", value: "rfc2822" },
    { option: "Custom", value: "custom" },
  ];
  const dropdownfilter = [
    { option: "Mass Update", value: "MU" },
    { option: "Single Row", value: "RD" },
    { option: "Both", value: "BD" },
  ];
  const iconPosition = [
    { option: "Prefix", value: "PF" },
    { option: "Suffix", value: "SF" },
  ];
  const iconList = [
    { option: "Cash", value: "BsCashStack" },
    { option: "Rupee", value: "BsCurrencyRupee" },
  ];
  const showonOptions = [
    { option: "Screen", value: "1" },
    { option: "Popup", value: "0" },
  ];
  const aggregateOptions = [
    { option: "Aggregate Data", value: "AD" },
    { option: "Group By", value: "GD" },
    { option: "First Row", value: "FR" },
    { option: "Hide Data", value: "HD" },
  ];

  const dropdown_Condition = [
    { option: "Check All Checkbox", value: "1" },
    { option: "Partial Submit", value: "2" },
  ];
  const dropDownOptions = [
    { option: "Show Value", value: "V" },
    { option: "Show Label", value: "L" },
    { option: "Show Both", value: "B" },
  ];

  const hyperlinkdata = [
    // { option: "Formview", value: "FV" },
    { option: "API", value: "API" },
    { option: "Payload Data", value: "PD" },
    { option: "Product List", value: "productlist" },
    { option: "Form View", value: "formview" },
  ];
  const defaultfilterOptions = [
    { option: "contextuser_id", value: "==.contextuser_id" },
    {
      option: "contextuser_branchid",
      value: "array_contains_any.contextuser_branchid",
    },
  ];
  const datatypeOptions = [
    { option: "Textbox", value: "textbox" },
    { option: "Date", value: "date" },
    { option: "Boolean", value: "boolean" },
    { option: "Image", value: "image" },
    { option: "Dropdown List", value: "dropdownlist" },
    { option: "INT", value: "int" },
    { option: "Float", value: "float" },
    { option: "DCB Family Data", value: "DCB" },
    { option: "Group ID", value: "group_id" },
    // { option: "Get Product List", value: "productlist" },
    { option: "Download / Upload", value: "Downloadfile" },
    { option: "Hyperlink", value: "hyperlink" },
    { option: "Select", value: "selectoption" },
    { option: "Block", value: "block" },
    { option: "JSON", value: "jsondata" },
  ];

  useEffect(() => {
    if (config) {
      if (config.autogeneratetxn === "1") {
        setShowConfigDropdown(true);
        if (config.selectConfig === "date_time") {
          setShowDateTimeFormatDropdown(true);
        }
        if (
          config.selectConfig === "transaction_no" ||
          config.selectConfig === "reference_no" ||
          config.selectConfig === "random"
        ) {
          setShowTextField(true);
        }
      }
    }
  }, [config]);

  let field_path = getBucketFieldString(path);
  let isArray = 0;
  if (field_path.indexOf(":") !== -1) {
    isArray = 1;
  } else {
    isArray = 0;
  }

  if (valueType == "string") {
    datatypeOptions.splice(datatypeOptions.length - 2, 2);
  } else {
    datatypeOptions.splice(0, datatypeOptions.length - 4);
  }

  useEffect(() => {
    payloadPathInSelectedForm.forEach((item, index) => {
      form.setFieldsValue({
        [`formview${index}`]: item.viewId,
        [`payloadpath${index}`]: item.payloadpath,
      });
    });
  }, [payloadPathInSelectedForm, form]);

  const valueChangeHandler = (changedValues, allValues) => {
    if (changedValues["globalMappingSequence"]) {
      allValues["mappingSequenceTimestamp"] = Date.now();
    }

    console.log("allValues", allValues);
    setConfig({ ...config, ...allValues });
  };

  useEffect(()=>{
    if (config.datatype === "block" || config.datatype === "jsondata") {
      const reversedPath = [...path].reverse();
      const extractedData = reversedPath.reduce((acc, currentKey) => acc && acc[currentKey], baseJson);
      console.log("extractedData--->", extractedData);

      const uniqueKeys = new Set();

      function extractKeys(obj, prefix = '') {
        Object.keys(obj).forEach(key => {
          const fullPath = prefix ? `${prefix}.${key}` : key;
          const value = obj[key];

          // Only add key if it's a primitive value (not object or array)
          if (
            value === null ||
            typeof value === "string" ||
            typeof value === "number" ||
            typeof value === "boolean"
          ) {
            uniqueKeys.add(fullPath);
          }

          // Recurse only if value is a non-null object and not an array
          if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            extractKeys(value, fullPath);
          }
        });
      }

      if (Array.isArray(extractedData) && extractedData.length > 0) {
        extractedData.forEach(item => {
          extractKeys(item);
        });
      }

      const result = Array.from(uniqueKeys);
      setblockTable(result);
      console.log(result);
    }
  },[config.datatype])
  useEffect(()=>{
  },[fieldSets])

  useEffect(() => {
    if (config.datecondition) {
      setFieldCount(config.datecondition.length);
  
      let temp = config.datecondition.map((item, index) => ({ ...item, id: index }));
  
      setFieldSets(temp);
    }
  }, [config.datecondition]); // ✅ Runs whenever `config.datecondition` updates

  // Function to add an input field
  const addInputBeforeApiCallCheck = () => {
    setBeforeApiCallCheck([...beforeApiCallCheck, { id: Date.now(), operator: "", value: "" }]);
    setConfig({ ...config, beforeApiCallCheck: [...beforeApiCallCheck, { id: Date.now(), operator: "", value: "" }] });
  };

  // Function to remove an input field by ID
  const removeInputBeforeApiCallCheck = (id) => {
    setBeforeApiCallCheck(beforeApiCallCheck.filter((input) => input.id !== id));
    setConfig({ ...config, beforeApiCallCheck: beforeApiCallCheck.filter((input) => input.id !== id) });
  };

  // Function to handle input change (optional)
  const handleInputChangeBeforeApiCallCheck = (id, operator, value) => {
    setBeforeApiCallCheck(
      beforeApiCallCheck.map((input) =>
        input.id === id ? { ...input, [operator]: value } : input
      )
    );
    setConfig({ ...config, beforeApiCallCheck: beforeApiCallCheck.map((input) =>
      input.id === id ? { ...input, [operator]: value } : input
    ) });
  };

  const handleCheckboxChange = (e, itemId) => {
    const value = e.target.value;
    const dropdowncondition = config.dropdowncondition || [];
    const checked = e.target.checked;

    // Check if the item is already in the dropdowncondition
    const existingSelection = dropdowncondition.find(
      (item) => item.filtereddropdownlist === itemId
    );

    if (checked) {
      if (existingSelection) {
        // Update the existing item
        const updatedSelections = {
          ...config,
          dropdowncondition: dropdowncondition.map((item) =>
            item.filtereddropdownlist === itemId
              ? { ...item, filtereddropdownlist: value }
              : item
          ),
        };
        setConfig(updatedSelections);
      } else {
        // Add new item
        const updatedSelections = {
          ...config,
          dropdowncondition: [
            ...dropdowncondition,
            { filtereddropdownlist: value, filteredCondition: null },
          ],
        };
        console.log("ConditionChange_", updatedSelections);

        setConfig(updatedSelections);
      }
    } else {
      const updatedSelections = {
        ...config,
        dropdowncondition: dropdowncondition.filter(
          (item) => item.filtereddropdownlist !== value
        ),
      };
      console.log("ConditionChange_1", updatedSelections);
      setConfig(updatedSelections);
    }
  };

  const handleConditionChange = (value, itemId) => {
    const dropdowncondition = config.dropdowncondition || [];

    const updatedSelections = {
      ...config,
      dropdowncondition: dropdowncondition.map((item) =>
        item.filtereddropdownlist === itemId
          ? { ...item, filteredCondition: value }
          : { ...item }
      ),
    };
    console.log("ConditionChange", value);

    setConfig(updatedSelections);
  };
  const handleMassValidationKey = (value, itemId) => {
    const dropdowncondition = config.dropdowncondition || [];

    const updatedSelections = {
      ...config,
      dropdowncondition: dropdowncondition.map((item) =>
        item.filtereddropdownlist === itemId
          ? { ...item, massValidationKey: value }
          : { ...item }
      ),
    };
    console.log("handleMassValidationKey", value);

    setConfig(updatedSelections);
  };
  const handleusedfor = (value, itemId) => {
    const dropdowncondition = config.dropdowncondition || [];

    const updatedSelections = {
      ...config,
      dropdowncondition: dropdowncondition.map((item) =>
        item.filtereddropdownlist === itemId
          ? { ...item, usedfor: value }
          : { ...item }
      ),
    };
    console.log("handleusedfor", value);

    setConfig(updatedSelections);
  };
  const handleMassValidationvalue = (value, itemId) => {
    const dropdowncondition = config.dropdowncondition || [];

    const updatedSelections = {
      ...config,
      dropdowncondition: dropdowncondition.map((item) =>
        item.filtereddropdownlist === itemId
          ? { ...item, massValidationvalue: value }
          : { massValidationvalue: value }
      ),
    };
    console.log("handleMassValidationKey", value);

    setConfig(updatedSelections);
  };

  const getDotSeparatedKeys = (data, prefix = "") => {
    const uniqueKeys = new Set();

    const processObject = (obj, currentPrefix) => {
      for (const key in obj) {
        const fullKey = currentPrefix ? `${currentPrefix}.${key}` : key;
        uniqueKeys.add(fullKey);

        if (typeof obj[key] === "object" && obj[key] !== null) {
          processObject(obj[key], fullKey);
        }
      }
    };

    data.forEach((item) => {
      processObject(item, prefix);
    });

    return Array.from(uniqueKeys);
  };

  const getpayloadpathdata = (data) => {
    const keys = getDotSeparatedKeys(referenceJson[data]);
    console.log("referenceJson", keys);
    setpayloadPathData(keys);

    setpayloadPathpopupConfig(
      keys.reduce(
        (acc, item) => ({ ...acc, [item]: { dropdown: "", textbox: "" } }),
        {}
      )
    );
  };

  const hyperpopupchange = (value, itemId, configfield) => {
    const dropdowncondition = config.hyperpopup || [];

    const itemExists = dropdowncondition.some(
      (item) => item.columnName === itemId
    );

    const updatedSelections = {
      ...config,
      hyperpopup: itemExists
        ? dropdowncondition.map((item) =>
          item.columnName === itemId
            ? { ...item, [configfield]: value }
            : item
        )
        : [...dropdowncondition, { columnName: itemId, [configfield]: value }], // Add new entry if not found
    };

    console.log("ConditionChange", updatedSelections);

    setConfig(updatedSelections);
  };

  // Function to toggle color picker display
  const toggleColorPicker = (index) => {
    const newColorPickers = { ...colorPickers };
    newColorPickers[index] = {
      display: newColorPickers[index] && newColorPickers[index].display
        ? !newColorPickers[index].display
        : true,
      color: newColorPickers[index] && newColorPickers[index].color
        ? newColorPickers[index].color
        : config[`color-${index}`] || "#ffffff",
    };
    setColorPickers(newColorPickers);
  };

  const handleColorChange = (color, index) => {
    const newColorPickers = { ...colorPickers };
    newColorPickers[index] = { ...newColorPickers[index], color: color.hex };
    setColorPickers(newColorPickers);

    valueChangeHandler(
      { [`color-${index}`]: color.hex },
      { ...config, [`color-${index}`]: color.hex }
    );
  };

  const addFieldSet = () => {
    setFieldSets([...fieldSets, { id: fieldSets.length }]);
    setFieldCount(fieldCount + 1);
    setvalidDateCondition(true)
  };
  // Function to remove a field set
  const removeFieldSet = (id) => {
    const updatedFieldSets = fieldSets.filter((fieldSet) => fieldSet.id !== id);
    setFieldSets(updatedFieldSets);
    setFieldCount(updatedFieldSets.length);
  };

  // Function to add a new row dynamically
  // const addConditionalRow = () => {    
  //   console.log("config=>", config)
  //   const newItem = {  condition_field_1: "",
  //     conditional_operator: "",
  //     condition_field_2: "",
  //     message_type: "",
  //     alert_message: "",
  //     manual_condition_1: "no",
  //     manual_condition_2: "no", 
  //   };
  //   setConfig({
  //     ...config,
  //     alert_condition: [...(config.alert_condition || []), newItem], // Append newItem to fileupload
  //   });
  // };

  // Function to remove a row dynamically
  // const removeConditionalRow = (index) => {
  //   const alert_condition = [...(config.alert_condition || [])];
  //   alert_condition.splice(index, 1);
  //   setConfig({ ...config, alert_condition: alert_condition });
  // };

  // Function to update any field dynamically
  // const handleConditionalChange = (field, value, index) => {
  //   const newfileupload = JSON.parse(JSON.stringify(config.alert_condition || []));
  //   newfileupload[index][field] = value;
  //   setConfig({ ...config, alert_condition: newfileupload });
  // };
  const handleConditionalChange = (key, value, rowIndex, condIndex) => {
    const updated = [...config.alert_condition];
    updated[rowIndex].conditions[condIndex][key] = value;
    setConfig({ ...config, alert_condition: updated });
  };
  
  const handleRowChange = (key, value, rowIndex) => {
    const updated = [...config.alert_condition];
    updated[rowIndex][key] = value;
    setConfig({ ...config, alert_condition: updated });
  };
  
  const addConditionalRow = () => {
    const newRow = {
      conditions: [{
        manual_condition: "no",
        condition_field: "",
        conditional_operator: "",
        math_manual: "no",
        math_field: "",
        math_operation: "",
      }],
      message_type: "",
      alert_message: ""
    };
    setConfig({ ...config, alert_condition: [...config.alert_condition, newRow] });
  };
  
  const removeConditionalRow = (rowIndex) => {
    const updated = [...config.alert_condition];
    updated.splice(rowIndex, 1);
    setConfig({ ...config, alert_condition: updated });
  };
  
  const addConditionToRow = (rowIndex) => {
    const updated = [...config.alert_condition];
  
    // Ensure the row and its conditions array exist
    if (!updated[rowIndex].conditions) {
      updated[rowIndex].conditions = [];
    }
  
    // Now safe to push
    updated[rowIndex].conditions.push({
      manual_condition: "no",
      condition_field: "",
      conditional_operator: "",
      math_manual: "no",
      math_field: "",
      math_operation: "",
    });
  
    setConfig({ ...config, alert_condition: updated });
  };
   
  const removeSingleCondition = (rowIndex, condIndex) => {
    const updated = [...config.alert_condition];
    updated[rowIndex].conditions.splice(condIndex, 1);
    setConfig({ ...config, alert_condition: updated });
  };
  

  const addPayloadPathInSelectedForm = () => {
    let update = [...payloadPathInSelectedForm];
    update = [...update, { id: Date.now(), payloadpath: "", viewId: "" }]
    setPayloadPathInSelectedForm(update);
  };

  const removePayloadPathInSelectedForm = (id) => {
    let update = [...payloadPathInSelectedForm];
    update = update.filter((input) => input.id !== id)
    setPayloadPathInSelectedForm(update);
  };

  const handlepayloadPathInSelectedForm = (item, value, type) => {
    if(type === 'viewId') {
      setPayloadPathInSelectedForm(payloadPathInSelectedForm.map((input) => (input.id === item.id ? { ...input, viewId: value } : input)));  
    } else if(type === 'payloadpath') {
      setPayloadPathInSelectedForm(payloadPathInSelectedForm.map((input) => (input.id === item.id ? { ...input, payloadpath: value } : input)));
    } else if(type === 'getvalue') {
      setPayloadPathInSelectedForm(payloadPathInSelectedForm.map((input) => (input.id === item.id ? { ...input, getvalue: value } : input)));
    } else if(type === 'value') {
      setPayloadPathInSelectedForm(payloadPathInSelectedForm.map((input) => (input.id === item.id ? { ...input, value: value } : input)));
    }
    const update = {
      ...config,
      payloadPathInSelectedForm: payloadPathInSelectedForm.map((input) => (input.id === item.id ? { ...input, [type]: value } : input)),
      extraFieldInForm: extraFieldInForm,
    }
    setConfig(update);
  }


  const [getOutputDataFields, setGetOutputDataFields] = useState([]);
  useEffect(() => {
    if (config.getdatafromapi) {
      handleGetFromAPIChanges(config.getdatafromapi);
    }
  }, [config.getdatafromapi])

  const extractGetAPIFieldNames = (outputData) => {
    // Check if outputData is valid and a string
    if (typeof outputData !== 'string' || !outputData.trim()) {
      return [];  // Return an empty array if the data is invalid or empty
    }

    const regex = /{{(.*?)}}/g;
    const fieldNames = [];
    let match;

    while ((match = regex.exec(outputData)) !== null) {
      if (match[1]) {  // Ensure that match[1] (the field name) is valid
        fieldNames.push(match[1]);
      }
    }

    return fieldNames;
  };

  const handleGetFromAPIChanges = (selectedApi) => {
    const selectedAction = apidata.find((item) => item.action_name === selectedApi);
    
    if (selectedAction) {
      const outputData = selectedAction.getoutputdata;
      
      // Extract field names from getoutputdata
      const fieldNames = extractGetAPIFieldNames(outputData);
      
      if (fieldNames.length > 1) {
        // Show dropdown with options to select a fieldname
        setGetOutputDataFields(fieldNames);
      } else {
        // Hide dropdown (or handle single field logic)
        setGetOutputDataFields([]);
      }

      form.setFieldsValue({ getOutputDataFieldName: undefined });
    } else {
      // Reset state if no valid action is found
      setGetOutputDataFields([]);
    }
  };

  return (
    <Form
      className="view_field_form"
      layout="vertical"
      form={form}
      onValuesChange={valueChangeHandler}
      initialValues={config}
    >
      <Row gutter={[24, 16]}>
        <Col span={6}>
          <Form.Item
            label="Field Name"
            name="fieldname"
            initialValue={config.fieldname}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Value Type"
            name="valueType"
            initialValue={config.valueType || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              <Option value="int">Int</Option>
              <Option value="float">Float</Option>
              <Option value="string">String</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Can Edit"
            name="isEdit"
            initialValue={config.isEdit || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="is Required"
            name="isRequired"
            initialValue={config.isRequired || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="is Required for Formview"
            name="isRequiredFormview"
            initialValue={config.isRequiredFormview || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="is Visible"
            name="isVisible"
            initialValue={config.isVisible || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Only Visible in Formview"
            name="onlyVisibleInFormview"
            initialValue={config.onlyVisibleInFormview || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="is Clickable"
            name="isClickable"
            initialValue={config.isClickable || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="is Search"
            name="isSearch"
            initialValue={config.isSearch || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="show Label?"
            name="showLabel"
            initialValue={config.showLabel || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Default Filter"
            name="defaultfilter"
            initialValue={config.defaultfilter || ""}
          >
            <Select>
              <Option value="">
                Select
              </Option>
              {defaultfilterOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Mass Update"
            name="massupdate"
            initialValue={config.massupdate || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {config.massupdate == 1 && (
          <>
            <Col span={3}>
              <Form.Item
                label="Show On"
                name="showon"
                initialValue={config.showon || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {showonOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Show Condition"
                name="showcondition"
                initialValue={config.showcondition || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Is Required?"
                name="massrequire"
                initialValue={config.massrequire || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.showcondition == 1 && (
              <>
                <Col span={3}>
                  <Form.Item
                    label="Select Field"
                    name="mass_condition_field"
                    initialValue={config.mass_condition_field || ""}
                  >
                    <Select showSearch>
                      <Option value="" disabled>
                        Select
                      </Option>
                      {fieldlist.map(({ BucketField, fieldname }) => (
                        <Option key={fieldname} value={BucketField}>
                          {fieldname}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item
                    label="Add Condition"
                    name="mass_condition_value"
                    initialValue={config.mass_condition_value}
                    placeholder="10,20,30"
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </>
            )}
            <Col span={3}>
              <Form.Item
                label="Use As Input"
                name="useasinput"
                initialValue={config.useasinput || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
       </Row>
       <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Add API?"
            name="addapi"
            initialValue={config.addapi || ""}
          >
            <Select onChange={(value) => setAddApiConfig(value)}>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {addApiConfig == "1" && (
          <Col span={4}>
            <Form.Item
              label="Select API"
              name="selectapi"
              initialValue={config.selectapi}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {apidata.map(({ action_name }) => (
                  <Option key={action_name} value={action_name}>
                    {action_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        </Row>
        <Row gutter={[24, 16]}>
        {/* Auto Generate Config Dropdown */}
        <Col span={3}>
          <Form.Item
            label="Auto Generate Config"
            name="autogeneratetxn"
          >
            <Select
              onChange={(value) => {
                setShowConfigDropdown(value === "1");
                if (value !== "1") {
                  setShowDateTimeFormatDropdown(false);
                  setShowTextField(false);
                  form.setFieldsValue({
                    selectConfig: undefined,
                    dateTimeFormat: undefined,
                    regularExpression: undefined,
                  });
                }
              }}
            >
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        {/* Second Dropdown: Select Config */}
        {showConfigDropdown && (
          <Col span={3}>
            <Form.Item
              label="Select Config"
              name="selectConfig"
            >
              <Select
                onChange={(value) => {
                  setShowDateTimeFormatDropdown(value === "date_time");
                  setShowTextField(
                    value === "transaction_no" || value === "random"
                  );
                  form.setFieldsValue({
                    dateTimeFormat: undefined,
                    regularExpression: undefined,
                  });
                }}
              >
                <Option value="" disabled>
                  Select
                </Option>
                {configOptions.map(({ option, value }) => (
                  <Option key={value} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}

        {/* Third Dropdown: Date-Time Format */}
        {showDateTimeFormatDropdown && (
          <Col span={3}>
            <Form.Item
              label="Date-Time Format"
              name="dateTimeFormat"
            >
              <Select>
                <Option value="" disabled>
                  Select Format
                </Option>
                {dateTimeFormats.map(({ option, value }) => (
                  <Option key={value} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}

        {/* Text Field: Enter Regular Expression */}
        {showTextField && (
          <Col span={3}>
            <Form.Item
              label="Enter Regular Expression"
              name="regularExpression"
            >
              <Input placeholder="Enter Regular Expression" />
            </Form.Item>
          </Col>
        )}

        <Col span={3}>
          <Form.Item
            label="Add to SUM"
            name="addtosum"
            initialValue={config.addtosum || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {config.addtosum == "1" && (
          <>
            <Col span={3}>
              <Form.Item
                label="Select Field"
                name="sumFieldlist"
                initialValue={config.sumFieldlist || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Can Submit Partial Amount"
                name="partial_amount"
                initialValue={config.partial_amount || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.partial_amount == 1 && (
              <Col span={3}>
                <Form.Item
                  label="Can Submit More Than Collection"
                  name="morethan_collection"
                  initialValue={config.morethan_collection || ""}
                >
                  <Select>
                    <Option value="" disabled>
                      Select
                    </Option>
                    {yesnoOptions.map(({ option, value }) => (
                      <Option key={option} value={value}>
                        {option}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </>
        )}
        <Col span={4}>
          <Form.Item
            label="Require Confirmation?"
            name="isConfirm"
            initialValue={config.isConfirm || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={[24, 16]}>
        <Col span={4}>
          <Form.Item
            label="Disable Edit"
            name="isEditDisable"
            initialValue={config.isEditDisable || ""}
          >
            <Select onChange={(value) => setEditDisableConfig(value)}>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {editDisableConfig == "1" && (
          <Col span={6}>
            <Form.Item
              label="Disable Value(bucket field operator value)"
              name="DisableOnFieldValue"
              initialValue={config.DisableOnFieldValue}
              placeholder="payload.status>40"
            >
              <Input />
            </Form.Item>
          </Col>
        )}
        <Col span={5}>
          <Form.Item
            label="Box Size"
            name="box_size"
            type="textarea"
            initialValue={config.box_size}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 16]}>
        {/* Data Type Dropdown */}
        <Col span={5}>
          <Form.Item
            label="Data Type"
            name="datatype"
            initialValue={config.datatype || ""}
          >
            <Select
              onChange={(value) => {
                setDatatypeConfig(value); // Update state for datatypeConfig
                valueChangeHandler({ datatype: value }, { ...config, datatype: value }); // Update parent state
              }}
            >
              <Option value="" disabled>
                Select
              </Option>
              {datatypeOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))
              }
            </Select>
          </Form.Item>
        </Col>
        {datatypeConfig == "block" && (
          <>          
            <Col span={4}>
              <Form.Item
                label="Data Format"
                name="dataformat"
                initialValue={config.dataformat || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  <Option value="json">
                    Json
                  </Option>
                  <Option value="table">
                    Table
                  </Option>                  
                </Select>
              </Form.Item>
            </Col>
            {
              config.dataformat == "table" && (
                <Col span={4}>
                  <Form.Item
                    label="Select Table Data"
                    name="selecttableData"
                    initialValue={config.selecttableData || ""}
                  >
                    <Select mode="multiple">
                      {blockTable.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )
            }
            <Col span={4}>
              <Form.Item
                label="Select data"
                name="selectData"
                initialValue={config.selectData || ""}
              >
                <Select onChange={(value) => setSelectData(value)}>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.selectData == "1" && <Col span={4}>
              <Form.Item
                label="Selection Type"
                name="selectionType"
                initialValue={config.selectionType || ""}
              >
                <Select onChange={(value) => setSelectionType(value)}>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {[{option:'radio', value: 'radio'}, {option:'checkbox', value: 'checkbox'}].map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>}
            <Col span={3}>
              <Form.Item
                label="Save Data In Other Field"
                name="otherField"
                initialValue={config.otherField || ""}
              >
                <Select onChange={(value) => setOtherField(value)}>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
          <Form.Item
            label="Other Field"
            name="otherFieldName"
            initialValue={config.otherFieldName}
          >
            <Input />
          </Form.Item>
        </Col>
          </>
        )}
        {datatypeConfig == "textbox" && (
          <><Col span={3}>
            <Form.Item
              label="Verify Input"
              name="verify_input"
              initialValue={config.verify_input || ""}
            >
              <Select>
                <Option value="" disabled>
                  Select
                </Option>
                {yesnoOptions.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          
          {config.verify_input == "1" && (
            <Col span={5}>
              <Form.Item
                label="Select API"
                name="verify_input_api"
                initialValue={config.verify_input_api}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {apidata.map(({ action_name }) => (
                    <Option key={action_name} value={action_name}>
                      {action_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          </>          
        )}
        {datatypeConfig == "selectoption" && (
          <>
            <Col span={4}>
              <Form.Item
                label="Select API"
                name="selectoption"
                initialValue={config.selectoption}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {apidata.map(({ action_name }) => (
                    <Option key={action_name} value={action_name}>
                      {action_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
        {datatypeConfig == "Downloadfile" && (
          <>
            <Col span={5}>
              <Form.Item
                label="Is Upload"
                name="isupload"
                initialValue={config.isupload || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.isupload == "1" && (
              <Col span={6}>
                <Form.Item
                  label="Household Id"
                  name="payloadpathIsupload"
                  initialValue={config.payloadpathIsupload}
                >
                  <Input />
                </Form.Item>
              </Col>
            )}
            <Col span={5}>
              <Form.Item
                label="Document Group"
                name="doc_group"
                initialValue={config.doc_group || ""}
              >
                <Select onChange={(e) => getdoctype(e)}>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {document_group &&
                    document_group.map(
                      ({
                        upload_document_type_group_name,
                        upload_document_type_group_id,
                      }) => (
                        <Option
                          key={upload_document_type_group_name}
                          value={upload_document_type_group_id}
                        >
                          {upload_document_type_group_name}
                        </Option>
                      )
                    )}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Download single file directly ?"
                name="singlefile_direct"
                initialValue={config.singlefile_direct || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* Conditionally render Sync/Async dropdown if "Download / Upload" is selected */}
            {/* <Col span={5}>
              <Form.Item label="File Upload Mode" name="syncAsync">
              <Select allowClear placeholder="Select">
                  {syncAsyncOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
          </>
        )}
        {config.isupload == "1" && (
          <>
            {(config.fileupload || []).map((item, index) => (
              <Row key={index} gutter={16} style={{ marginBottom: "16px" }}>
                {/* Dropdown for Select Type */}
                <Col span={4}>
                  <Form.Item label="Select Type">
                    <Select
                      value={item.selectType}
                      onChange={(value) =>
                        handleInputChange(value, index, "selectType")
                      }
                      placeholder="Select Type"
                    >
                      <Option value="" disabled>
                        Select
                      </Option>
                      {document_type.map(
                        ({
                          upload_document_type_name,
                          upload_document_type_id,
                        }) => (
                          <Option
                            key={upload_document_type_name}
                            value={upload_document_type_id}
                          >
                            {upload_document_type_name}
                          </Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Textbox for File Type */}
                <Col span={4}>
                  <Form.Item label="File Type">
                    <Input
                      value={item.UploadType}
                      onChange={(e) =>
                        handleInputChange(e.target.value, index, "UploadType")
                      }
                      placeholder="File Type"
                    />
                  </Form.Item>
                </Col>

                {/* Textbox for File Size */}
                <Col span={4}>
                  <Form.Item label="File Size">
                    <Input
                      value={item.UploadSize}
                      onChange={(e) =>
                        handleInputChange(e.target.value, index, "UploadSize")
                      }
                      placeholder="File Size"
                    />
                  </Form.Item>
                </Col>

                {/* Textbox for File Path */}
                <Col span={6}>
                  <Form.Item label="File Path">
                    <Input
                      value={item.UploadPath}
                      onChange={(e) =>
                        handleInputChange(e.target.value, index, "UploadPath")
                      }
                      placeholder="File Path"
                    />
                  </Form.Item>
                </Col>

                {/* Textbox for File Name */}
                <Col span={4}>
                  <Form.Item label="File Name">
                    <Input
                      value={item.UploadName}
                      onChange={(e) =>
                        handleInputChange(e.target.value, index, "UploadName")
                      }
                      placeholder="File Name"
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label="Is Required">
                    <Select
                      value={item.UploadRequired}
                      onChange={(value) =>
                        handleInputChange(value, index, "UploadRequired")
                      }
                      placeholder="Select"
                    >
                      <Option value="" disabled>
                        Select
                      </Option>
                      {yesnoOptions.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label="Is Multiple Upload">
                    <Select
                      value={item.UploadIsMultiple}
                      onChange={(value) =>
                        handleInputChange(value, index, "UploadIsMultiple")
                      }
                      placeholder="Select"
                    >
                      <Option value="" disabled>
                        Select
                      </Option>
                      {yesnoOptions.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label="Retention Period">
                    <DatePicker
                      format={"YYYY-MM-DD"}
                      value={moment(item.UploadRetention)}
                      onChange={(e) =>
                        handleInputChange(
                          moment(e).format("YYYY-MM-DD"),
                          index,
                          "UploadRetention"
                        )
                      }
                      placeholder="Retention Period"
                    />
                  </Form.Item>
                </Col>

                {/* Remove Button */}
                <Col span={2}>
                  <Button
                    type="danger"
                    onClick={() => handleRemove(index)}
                    disabled={config.fileupload.length === 1}
                  >
                    -
                  </Button>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Is Important File"
                    name="isImportantFile"
                    initialValue={config.isImportantFile || ""}
                  >
                    <Select placeholder="Select">
                      <Option value="" disabled>
                        Select
                      </Option>
                      {yesnoOptions.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Use Signed URL"
                    name="useSignedURL"
                    initialValue={config.useSignedURL || ""}
                  >
                    <Select placeholder="Select">
                      <Option value="" disabled>
                        Select
                      </Option>
                      {yesnoOptions.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Verify Uploaded File"
                    name="verifyUploadedFile"
                    initialValue={config.verifyUploadedFile || ""}
                  >
                    <Select placeholder="Select">
                      <Option value="" disabled>
                        Select
                      </Option>
                      {yesnoOptions.map(({ option, value }) => (
                        <Option key={option} value={value}>
                          {option}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            ))}

            {/* Add Button */}
            <Form.Item>
              <Button type="primary" onClick={handleAdd}>
                +
              </Button>
            </Form.Item>
          </>
        )}
        {datatypeConfig == "DCB" && (
          <Col span={5}>
            <Form.Item
              label="Select View"
              name="exprow"
              initialValue={config.exprow || ""}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {viewlist.map(({ view_id, view_name }) => (
                  <Option key={view_id} value={view_id}>
                    {view_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}

        {datatypeConfig == "hyperlink" && (
          <Col span={5}>
            <Form.Item
              label="Get Hyperlink Data"
              name="gethyperlinkdata"
              initialValue={config.gethyperlinkdata || ""}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {hyperlinkdata.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        {config.gethyperlinkdata == "API" && (
          <Col span={3}>
            <Form.Item
              label="Select API"
              name="hyperlinkapi"
              initialValue={config.hyperlinkapi}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {apidata.map(({ action_name }) => (
                  <Option key={action_name} value={action_name}>
                    {action_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        {config.gethyperlinkdata == "PD" && (
          <>
            <Col span={3}>
              <Form.Item
                label="Payload Path"
                name="HyperlinkPayload"
                type="textarea"
                initialValue={config.HyperlinkPayload}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button
                className="add_view_field_button"
                onClick={() => getpayloadpathdata(config.HyperlinkPayload)}
                type="primary"
              >
                Config Popup Data
              </Button>
            </Col>

            {payloadPathData && (
              <table className="table">
                <thead>
                  <th>Path</th>
                  <th>Is Visible</th>
                  <th>label</th>
                </thead>
                <tbody>
                  {payloadPathData.map((pathdata, index) => {
                    return (
                      <tr key={index}>
                        <td>{pathdata}</td>
                        <td>
                          <Select
                            onChange={(value) =>
                              hyperpopupchange(value, pathdata, "isVisible")
                            }
                          >
                            <Option value="" disabled>
                              Select
                            </Option>
                            {yesnoOptions.map(({ option, value }) => (
                              <Option key={option} value={value}>
                                {option}
                              </Option>
                            ))}
                          </Select>
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              hyperpopupchange(
                                e.target.value,
                                pathdata,
                                "haslabel"
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                    // <Row key={index} className="w-100 ml-2">
                    //   <Col span={8}>{pathdata}</Col>
                    //   <Col span={4}>
                    //     <Select onChange={(value) => setRedirectConfig(value)}>
                    //       <Option value="" disabled>
                    //         Select
                    //       </Option>
                    //       {yesnoOptions.map(({ option, value }) => (
                    //         <Option key={option} value={value}>
                    //           {option}
                    //         </Option>
                    //       ))}
                    //     </Select>
                    //   </Col>
                    //   <Col span={8}>
                    //     <Input />
                    //   </Col>
                    // </Row>
                  })}
                </tbody>
              </table>
            )}
          </>
        )}
        {config.gethyperlinkdata == "productlist" && (
          <>
            <Col span={5}>
              <Form.Item
                label="Save Product ID"
                name="productid"
                initialValue={config.productid || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Save Product Amount"
                name="productlist"
                initialValue={config.productlist || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Save Product Tenure"
                name="tenure"
                initialValue={config.tenure || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
        {datatypeConfig == "sub_view" && (
          <Col span={5}>
            <Form.Item
              label="Select View"
              name="exprow"
              initialValue={config.exprow || ""}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {viewlist.map(({ view_id, view_name }) => (
                  <Option key={view_id} value={view_id}>
                    {view_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        {datatypeConfig == "dropdownlist" && (
          <>
            <Col span={5}>
              <Form.Item
                label="dropdownlist"
                name="dropdownlist"
                initialValue={config.dropdownlist || ""}
              >
                <Select mode="multiple" showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {dropdownlist.map(({ dropdown_id, dropdown_name }) => (
                    <Option key={dropdown_id} value={dropdown_id}>
                      {dropdown_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button
                className="delete_view_field"
                type="primary"
                disabled={!config.dropdownlist}
                onClick={() => filteroutput(config.dropdownlist)}
              >Config Output</Button>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Show Dropdown Options"
                name="dropDownOptions"
                initialValue={config.dropDownOptions || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {dropDownOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
        {datatypeConfig == "Uploadfile" && (
          <>
            <Row gutter={[24, 16]}>
              <Col span={5}>
                <Form.Item
                  label="File Type"
                  name="UploadType"
                  initialValue={config.UploadType}
                >
                  <Input placeholder="PDF,JPG,XLSX" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="File Size (In MB)"
                  name="UploadSize"
                  initialValue={config.UploadSize}
                >
                  <Input placeholder="2" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="File Path"
                  name="UploadPath"
                  initialValue={config.UploadPath}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="File Name"
                  name="UploadName"
                  initialValue={config.UploadName}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        {config.gethyperlinkdata == "formview" && (
          <>
            <Col span={5}>
              <Form.Item
                label="Select Form View"
                name="formview"
                initialValue={config.formview || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {viewlist.map(
                    ({ view_id, view_name, field_mapping, form_mapping }) => {
                      console.log("viewlist1234", viewlist);
                      console.log("viewlist1234", config);
                      if (
                        form_mapping &&
                        form_mapping.length
                        // form_mapping[form_mapping.length - 1].task_data
                      ) {
                        return (
                          <Option key={view_id} value={view_id}>
                            {view_name}
                          </Option>
                        );
                      } else {
                        return;
                      }
                    }
                  )}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
        {/* Dynamic Fields for Data Type = "Date" */}
        {config.datatype === "date"  && (
          <>
            <Col span={5}>
              <Form.Item
                label="Display Format"
                name="displaydateformat"
                type="textarea"
                placeholder="dd/mm/yyyy"
                initialValue={config.displaydateformat}
              >
                <Input />
              </Form.Item>
            </Col>
            {validDate && fieldSets.map((fieldSet, index) => (
              <React.Fragment key={fieldSet.id}>
                <Col span={5}>
                  <Form.Item
                    label="Operator"
                    name={`operator-${fieldSet.id}`}
                    initialValue={config[`operator-${fieldSet.id}`] || ""}
                  >
                    <Select>
                      <Option value="" disabled>
                        Select Operator
                      </Option>
                      <Option value="==">==</Option>
                      <Option value="exists">exists</Option>
                      <Option value=">">&#62;</Option>
                      <Option value="<">&#60;</Option>
                      <Option value="!=">!=</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item
                    label="Day"
                    name={`day-${fieldSet.id}`}
                    initialValue={
                      config[`day-${fieldSet.id}`] !== undefined ? config[`day-${fieldSet.id}`] : ""
                    }
                  >
                    <Select
                      onChange={(value) => {
                        valueChangeHandler(
                          { [`day-${fieldSet.id}`]: value },
                          { ...config, [`day-${fieldSet.id}`]: value }
                        );
                      }}
                    >
                      <Option value="" disabled>
                        Select Day
                      </Option>
                      {Array.from({ length: 37 }, (_, index) => index - 5).map((day) => (
                        <Option key={day} value={day}>
                          {day === 0 ? "0 Day" : `${day} Day${Math.abs(day) === 1 ? "" : "s"}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={5}>
                  <button
                    className="btn btn-primary"
                    onClick={() => toggleColorPicker(fieldSet.id)}
                    style={{ width: "60%", marginTop: "25px" }}
                  >
                    {colorPickers[fieldSet.id] && colorPickers[fieldSet.id].display
                      ? "Close Picker"
                      : "Pick Color"}
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => removeFieldSet(fieldSet.id)}
                    style={{ marginTop: "25px", marginLeft: "10px" }}
                  >
                    -
                  </button>
                </Col>                
                {/* Color Picker */}
                {colorPickers[fieldSet.id] && colorPickers[fieldSet.id].display && (
                  <Col span={5}>
                    <Form.Item label="Color" name={`color-${fieldSet.id}`}>
                      <ChromePicker
                        color={
                          (colorPickers[fieldSet.id] && colorPickers[fieldSet.id].color) ||
                          config[`color-${fieldSet.id}`] ||
                          "#ffffff"
                        }
                        onChangeComplete={(color) => handleColorChange(color, fieldSet.id)}
                      />
                    </Form.Item>
                  </Col>
                )}
              </React.Fragment>
            ))}

            <Col span={5}>
              <button
                className="btn btn-success"
                onClick={addFieldSet}
                style={{ width: "60%", marginTop: "25px" }}
                disabled={!validDate}
              >
                + Add Field Set
              </button>
            </Col>
          </>
        )}
        {datatypeConfig == "hyperlink" && (
          <Col span={5}>
            <Form.Item
              label="Get Hyperlink Data"
              name="gethyperlinkdata"
              initialValue={config.gethyperlinkdata || ""}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {hyperlinkdata.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        {config.gethyperlinkdata == "API" && (
          <Col span={3}>
            <Form.Item
              label="Select API"
              name="hyperlinkapi"
              initialValue={config.hyperlinkapi}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {apidata.map(({ action_name }) => (
                  <Option key={action_name} value={action_name}>
                    {action_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        {config.gethyperlinkdata == "PD" && (
          <Col span={3}>
            <Form.Item
              label="Payload Path"
              name="HyperlinkPayload"
              type="textarea"
              initialValue={config.HyperlinkPayload}
            >
              <Input />
            </Form.Item>
          </Col>
        )}
        {config.gethyperlinkdata == "productlist" && (
          <>
            <Col span={5}>
              <Form.Item
                label="Save Product ID"
                name="productid"
                initialValue={config.productid || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Save Product Amount"
                name="productlist"
                initialValue={config.productlist || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Save Product Tenure"
                name="tenure"
                initialValue={config.tenure || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}

        <Col span={3}>
          <Form.Item
            label="Redirect"
            name="isRedirect"
            initialValue={config.isRedirect || ""}
          >
            <Select onChange={(value) => setRedirectConfig(value)}>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {redirectConfig == "1" && (
          <>
            <Col span={5}>
              <Form.Item
                label={`use {"{{ fieldname }}"}`}
                name="RedirectData"
                type="textarea"
                initialValue={config.RedirectData}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Add Redirect Condition"
                name="RedirectCondition"
                initialValue={config.RedirectCondition}
              >
                <Input />
              </Form.Item>
            </Col>
          </>
        )}
        </Row>
        <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="EditinPopup"
            name="EditinPopup"
            initialValue={config.EditinPopup || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
          <Col span={3}>
          <Form.Item
            label="Delete in Popup"
            name="DeleteinPopup"
            initialValue={config.DeleteinPopup || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        </Row>
        <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Exclude Value"
            name="ExcludeValueflag"
            initialValue={config.ExcludeValueflag || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {config.ExcludeValueflag == 1 && (
          <Col span={3}>
            <Form.Item
              label="values"
              name="ExcludeValue"
              initialValue={config.ExcludeValue || ""}
            >
              <Input placeholder="val1,val2" />
            </Form.Item>
          </Col>
        )}
        {isArray == 1 && (
          <>
            <Col span={4}>
              <Form.Item
                label="Pick Value From Array"
                name="picklast"
                initialValue={config.picklast || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.picklast == 1 && (
              <Col span={3}>
                <Form.Item
                  label="Array Index"
                  name="pickindex"
                  initialValue={config.pickindex || ""}
                >
                  <Input />
                </Form.Item>
              </Col>
            )}
          </>
        )}
        </Row>
        <Row gutter={[24, 16]}>
        <Col span={5}>
          <Form.Item
            label="Field Length"
            name="FieldLength"
            initialValue={config.FieldLength || null}
          >
            <Input />
          </Form.Item>
        </Col><Col span={5}>
          <Form.Item
            label="Field Length Error Message"
            name="FieldLengthErrorMessage"
            initialValue={config.FieldLengthErrorMessage || null}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Use as Add Data Before"
            name="add_data_before"
            initialValue={config.add_data_before || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Check condition before api call"
            name="checkconditionbeforeapicall"
            initialValue={config.checkconditionbeforeapicall || ""}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        </Row>
      <Row gutter={[24, 16]}>
        {config.checkconditionbeforeapicall == "1" && 
        (
          config.beforeApiCallCheck && config.beforeApiCallCheck.map(({ id, operator, value }, index) => (
            <Row key={id} gutter={[24, 16]}>
              <Col span={8}>
                <Form.Item
                  label="Operator"
                  name={`beforeApiCallCheck[${index}].operator`}
                  initialValue={config.beforeApiCallCheck && config.beforeApiCallCheck[index] && (config.beforeApiCallCheck)[index].operator || ""}
                >
                  <Select onChange={(val) => handleInputChangeBeforeApiCallCheck(id, "operator", val)}>
                    <Option value="" disabled>
                      Select
                    </Option>
                    {mathOperatorOptions.map(({ option, value }) => (
                      <Option key={option} value={value}>
                        {option}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item
                  label="Value"
                  name={`beforeApiCallCheck[${index}].value`}
                  initialValue={config.beforeApiCallCheck && config.beforeApiCallCheck[index] && (config.beforeApiCallCheck)[index].value || ""}
                >
                  <Input onChange={(e) => handleInputChangeBeforeApiCallCheck(id, "value", e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={2} style={{ marginLeft: "10px" }}>
                <Button
                  className="delete_view_field"
                  type="primary"
                  danger
                  onClick={() => removeInputBeforeApiCallCheck(id)}
                >
                  <DeleteFilled />
                </Button>
              </Col>
            </Row>
          ))
        )}
        {config.checkconditionbeforeapicall == "1" && <Col span={3}>
          <Button
            className="add_view_field_button"
            onClick={addInputBeforeApiCallCheck}
            type="primary"
          >
            <PlusOutlined /> 
          </Button>
        </Col>}
      </Row>
      {dropdownResponse && (
        <Row gutter={[24, 16]}>
          <Col span={24}>
            {/* <Form.Item
                  name="filtereddropdownlist"
                  initialValue={config.filtereddropdownlist || ""}
                >
                  <Checkbox.Group
                    options={dropdownResponse}
                    //onChange={onChange}
                    defaultValue={config.filtereddropdownlist || ""}
                  />
                </Form.Item> */}
            <table className="table">
              <thead>
                <th>#</th>
                <th>Use For</th>
                {config.massupdate == 1 && <><th>Mass Condition</th>
                  <th>Validation to Stop Mass Processing</th></>}
              </thead>
              <tbody>
                {dropdownResponse &&
                  dropdownResponse.map((showdata) => {
                    const dropdowncondition = config.dropdowncondition || [];
                    const existingSelection = dropdowncondition.find(
                      (item) =>
                        item.filtereddropdownlist === showdata.item_value
                    );

                    return (
                      <tr key={showdata.item_id}>
                        <td>
                          <Checkbox
                            value={showdata.item_value}
                            checked={!!existingSelection}
                            onChange={(e) =>
                              handleCheckboxChange(e, showdata.item_value)
                            }
                          >
                            {showdata.item_name + " - " + showdata.item_value}
                          </Checkbox>
                        </td>
                        <td>
                          <Select
                            onChange={(value) =>
                              handleusedfor(
                                value,
                                showdata.item_value
                              )
                            }
                            value={
                              existingSelection
                                ? existingSelection.usedfor
                                : ""
                            }
                            placeholder="Select"
                          >
                            {(config.massupdate == 1 ? dropdownfilter : dropdownfilter.filter(item => item.value === "RD")).map(({ option, value }) => (
                              <Option key={option} value={value}>
                                {option}
                              </Option>
                            ))}
                          </Select>
                        </td>
                        {config.massupdate == 1 && <>
                          <td>
                            <Select
                              onChange={(value) =>
                                handleConditionChange(value, showdata.item_value)
                              }
                              value={
                                existingSelection
                                  ? existingSelection.filteredCondition
                                  : undefined
                              }
                              placeholder="Select"
                            >
                              {dropdown_Condition.map(({ option, value }) => (
                                <Option key={value} value={value}>
                                  {option}
                                </Option>
                              ))}
                            </Select>
                          </td>
                          <td>
                            <Select
                              onChange={(value) =>
                                handleMassValidationKey(
                                  value,
                                  showdata.item_value
                                )
                              }
                              value={
                                existingSelection
                                  ? existingSelection.massValidationKey
                                  : undefined
                              }
                              placeholder="Select"
                            >
                              {allRules.map(({ field }) => (
                                <Option key={field} value={field}>
                                  {field}
                                </Option>
                              ))}
                            </Select>
                            <Select
                              mode="multiple"
                              onChange={(value) =>
                                handleMassValidationvalue(
                                  value,
                                  showdata.item_value
                                )
                              }
                              value={
                                existingSelection
                                  ? existingSelection.massValidationvalue
                                  : undefined
                              }
                              placeholder="Select"
                            >
                              {allRules.length > 0 &&
                                allRules[0].values.map((field) => (
                                  <Option key={field} value={field}>
                                    {field}
                                  </Option>
                                ))}
                            </Select>
                          </td>
                        </>}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </Col>
        </Row>
      )}
      <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
            label="Get From API"
            name="getfromapi"
            initialValue={config.getfromapi || "0"}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {config.getfromapi == 1 && (
          <>
            <Col span={5}>
              <Form.Item
                label="Select API"
                name="getdatafromapi"
                initialValue={config.getdatafromapi || ""}
              >
                <Select showSearch onChange={handleGetFromAPIChanges}>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {apidata.map(({ action_name }) => (
                    <Option key={action_name} value={action_name}>
                      {action_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {getOutputDataFields.length > 1 && 
              <Col span={5}>
                <Form.Item
                  label="Select API Output"
                  name="getOutputDataFieldName"
                  initialValue={config.getOutputDataFieldName || ""}
                >
                  <Select showSearch>
                    <Option value="" disabled>
                      Select
                    </Option>
                    {getOutputDataFields.map(( field ) => (
                      <Option key={field} value={field}>
                        {field}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            }
          </>
        )}
      </Row>
      <Row gutter={[24, 16]}>
        <Col span={4}>
          <Form.Item
            label="Arithmetic Operation"
            name="arithmeticOperation"
            initialValue={config.arithmeticOperation ? "1" : "0"}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              <Option value="1">Yes</Option>
              <Option value="0">No</Option>
            </Select>
          </Form.Item>
        </Col>
        
        {config.arithmeticOperation === "1" && (
          <>
            <Col span={3}>
              <Form.Item
                label="Select Operator"
                name="arithmeticOperator"
                initialValue={config.operator || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  <Option value="+">+</Option>
                  <Option value="-">-</Option>
                  <Option value="*">*</Option>
                  <Option value="/">/</Option>
                  <Option value="%">%</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                label="Enter Operation"
                name="operationValue"
                initialValue={config.operationValue || undefined}
                getValueFromEvent={(e) => {
                  const value = e.target.value;
                  return value === '' ? undefined : Number(value);
                }}
                getValueProps={(value) => ({
                  value: value !== undefined && value !== null ? value : ''
                })}
              >
                <Input 
                  placeholder="Enter value or number" 
                  type="number"
                />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <Row gutter={[24, 16]}>
        <Col span={3}>
          <Form.Item
              label="Custom Field"
              name="custom_field"
              initialValue={config.custom_field || "0"}
            >
              <Select>
                <Option value="">
                  Select
                </Option>
                {yesnoOptions.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
        </Col>
        {config.custom_field == "1" && 
          <>
            <Col span={3}>
              <Form.Item
                  label="Default Value"
                  name="custom_defaultval"
                  initialValue={config.custom_defaultval || null}
                >
                <Input />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                  label="Show on Screen"
                  name="show_on_screen"
                  initialValue={config.show_on_screen || null}
                >
                <Select>
                  <Option value="">
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                  label="Api Call"
                  name="isglobal_api_call"
                  initialValue={config.isglobal_api_call || null}
                >
                <Select>
                  <Option value="">
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {
              config.isglobal_api_call == "1" && <Col span={3}>
              <Form.Item
              label="Select API"
              name="global_api_call"
              initialValue={config.global_api_call}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {apidata.map(({ action_name }) => (
                  <Option key={action_name} value={action_name}>
                    {action_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            </Col>
            }
            <Col span={3}>
              <Form.Item
                  label="Manuall Input"
                  name="manually_input"
                  initialValue={config.manually_input || null}
                >
                <Select>
                  <Option value="">
                    Select
                  </Option>
                  {yesnoOptions.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {config.manually_input == "0" &&
            <>
            <Col span={3}>
              <Form.Item
                label="Select Field"
                name="manuall_condition_field"
                initialValue={config.manuall_condition_field || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Operator"
                name="manuall_operator"
                initialValue={config.manuall_operator || ""}
              >
                <Select>
                  <Option value="" disabled>
                    Select Operator
                  </Option>
                  <Option value="sum">column sum</Option>
                  <Option value="+">+</Option>
                  <Option value="-">-</Option>
                  <Option value="/">/</Option>
                  <Option value="*">*</Option>                  
                </Select>
              </Form.Item>
            </Col>
            {config.manuall_operator != "sum" && <Col span={3}>
              <Form.Item
                label="Select Field"
                name="manuall_condition_field_with"
                initialValue={config.manuall_condition_field_with || ""}
              >
                <Select showSearch>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {fieldlist.map(({ BucketField, fieldname }) => (
                    <Option key={fieldname} value={BucketField}>
                      {fieldname}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>}
            </>
            }
          </>
        }
      </Row>
      <Row gutter={[24, 16]} style={{border:"1px solid",pedding:"1px"}}>
        {config.alert_condition.map((row, rowIndex) => (
          <div key={rowIndex} className="p-4" style={{borderBottom:"1px solid",width:"100%"}}>
            {(row.conditions || []).map((condition, condIndex) => (
              <Row key={condIndex} gutter={[24, 16]} style={{ marginBottom: 8 }}>
                {/* Manual Condition */}
                <Col>
                  <Form.Item label="Manual Condition">
                    <Select
                      value={condition.manual_condition}
                      onChange={(value) => handleConditionalChange("manual_condition", value, rowIndex, condIndex)}
                      placeholder="Select"
                    >
                      <Option value="no">No</Option>
                      <Option value="yes">Yes</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {/* Conditional Field */}
                <Col>
                  <Form.Item label="Condition Field">
                    {condition.manual_condition === "yes" ? (
                      <Input
                        placeholder="Enter manual field"
                        value={condition.condition_field}
                        onChange={(e) =>
                          handleConditionalChange("condition_field", e.target.value, rowIndex, condIndex)
                        }
                      />
                    ) : (
                      <Select
                        showSearch
                        value={condition.condition_field}
                        onChange={(value) =>
                          handleConditionalChange("condition_field", value, rowIndex, condIndex)
                        }
                        placeholder="Select"
                      >
                        <Option value="" disabled>Select</Option>
                        {fieldlist.map(({ BucketField, fieldname }) => (
                          <Option key={fieldname} value={BucketField}>
                            {fieldname}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                {/* Operator */}
                <Col>
                  <Form.Item label="Operator">
                    <Select
                      value={condition.conditional_operator}
                      onChange={(value) => handleConditionalChange("conditional_operator", value, rowIndex, condIndex)}
                      placeholder="Operator"
                    >
                      <Option value="">Select</Option>
                      <Option value="==">==</Option>
                      <Option value="<">&lt;</Option>
                      <Option value=">">&gt;</Option>
                      <Option value="<=">&lt;=</Option>
                      <Option value=">=">&gt;=</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {/* Math Manual Condition */}
                <Col>
                  <Form.Item label="Math Manual Condition">
                    <Select
                      value={condition.math_manual}
                      onChange={(value) => handleConditionalChange("math_manual", value, rowIndex, condIndex)}
                      placeholder="Select"
                    >
                      <Option value="no">No</Option>
                      <Option value="yes">Yes</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {/* Math Operator */}
                <Col>
                  <Form.Item label="Math Operator">
                    <Select
                      value={condition.math_operation}
                      onChange={(value) => handleConditionalChange("math_operation", value, rowIndex, condIndex)}
                      placeholder="Math Operator"
                    >
                      <Option value="" disabled>Select</Option>
                      <Option value="+">+</Option>
                      <Option value="-">-</Option>
                      <Option value="*">*</Option>
                      <Option value="/">/</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {/* Math Field */}
                <Col>
                  <Form.Item label="Math Field">
                    {condition.math_manual === "yes" ? (
                      <Input
                        placeholder="Enter manual field"
                        value={condition.math_field}
                        onChange={(e) =>
                          handleConditionalChange("math_field", e.target.value, rowIndex, condIndex)
                        }
                      />
                    ) : (
                      <Select
                        showSearch
                        value={condition.math_field}
                        onChange={(value) =>
                          handleConditionalChange("math_field", value, rowIndex, condIndex)
                        }
                        placeholder="Select"
                      >
                        <Option value="" disabled>Select</Option>
                        {fieldlist.map(({ BucketField, fieldname }) => (
                          <Option key={fieldname} value={BucketField}>
                            {fieldname}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>

                {/* Remove condition button */}
                <Col span={2}>
                  <Button
                    danger
                    onClick={() => removeSingleCondition(rowIndex, condIndex)}
                    style={{ marginTop: 30 }}
                    disabled={row.conditions.length === 1}
                  >
                    -
                  </Button>
                </Col>
              </Row>
            ))}

            {/* Add new condition to current alert row */}
            <Row>
              <Col span={6}>
                <Button type="dashed" onClick={() => addConditionToRow(rowIndex)} style={{ marginBottom: 16 }}>
                  + Add Condition
                </Button>
              </Col>
            </Row>

            {/* Remaining Fields: Message Type and Alert Message */}
            <Row gutter={[24, 16]}>
              <Col>
                <Form.Item label="Message Type">
                  <Select
                    value={row.message_type}
                    onChange={(value) => handleRowChange("message_type", value, rowIndex)}
                    placeholder="Select"
                  >
                    <Option value="">Select</Option>
                    <Option value="warning">Warning</Option>
                    <Option value="error">Error</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Alert Message">
                  <Input
                    placeholder="Enter alert message"
                    value={row.alert_message}
                    onChange={(e) =>
                      handleRowChange("alert_message", e.target.value, rowIndex)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Button
                  danger
                  onClick={() => removeConditionalRow(rowIndex)}
                  style={{ marginTop: 30 }}
                >
                  Remove Row
                </Button>
              </Col>
            </Row>
          </div>
        ))}

        {/* Add alert row */}
        <Col span={24}>
          <Button type="primary" onClick={addConditionalRow} style={{ marginTop: 16 }}>
            + Add Conditional Row
          </Button>
        </Col>
      </Row>

      <Row gutter={[24, 16]}>
        {view_type && view_type == "AV" && (
          <Col span={3}>
            <Form.Item
              label="Aggregate Column"
              name="aggregatecolumn"
              initialValue={config.aggregatecolumn || ""}
            >
              <Select showSearch>
                <Option value="" disabled>
                  Select
                </Option>
                {aggregateOptions.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        )}
        <Col span={3}>
          <Form.Item
            label="Mapping Sequence"
            name="globalMappingSequence"
            initialValue={config.globalMappingSequence || 9999}
          >
            <InputNumber min={1} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="Show Dropdown in view Filter"
            name="dropdown_in_filter"
            initialValue={config.dropdown_in_filter || "0"}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 16]}>
        <Col span={4}>
          <Form.Item
            label="Field to pass in FormView"
            name="extra_field_in_formview"
            initialValue={config.extraFieldInForm || "0"}
          >
            <Select onChange={(value) => setExtraFieldInForm(value)}>
              <Option value="0" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <button onClick={() => addPayloadPathInSelectedForm()}>+</button>
        </Col>
        {extraFieldInForm == "1" && payloadPathInSelectedForm && (
          payloadPathInSelectedForm.map((item, index) => {
            console.log("payloadPathInSelectedForm", payloadPathInSelectedForm);
            return (<>
              <Col span={5}>
          <Form.Item
            label="Select Form View"
            name={`formview${index}`}
            // initialValue={item.viewId || ""}
          >
            <Select showSearch value={item.viewId} onChange={(value) => handlepayloadPathInSelectedForm(item, value, 'viewId')}>
              <Option value="" disabled>
                Select
              </Option>
              {viewlist.map(
                ({ view_id, view_name, view_type, field_mapping, form_mapping }) => {
                  console.log("viewlist1234", viewlist);
                  console.log("viewlist1234", config);
                  if (
                    view_type == "FV" &&
                    form_mapping &&
                    form_mapping.length
                    // form_mapping[form_mapping.length - 1].task_data
                  ) {
                    return (
                      <Option key={view_id} value={view_id}>
                        {view_name}
                      </Option>
                    );
                  } else {
                    return;
                  }
                }
              )}
            </Select>
          </Form.Item>

          <Form.Item
            label="Payload Path"
            name={`payloadpath${index}`}
            // initialValue={item.payloadpath || ""}
          >
            <Select showSearch value={item.payloadpath} onChange={(value) => handlepayloadPathInSelectedForm(item, value, 'payloadpath')}>
              <Option value="" disabled>
                Select
              </Option>
              {payloadPathInSelectedForm[index].viewId && viewlist.find(view => view.view_id == payloadPathInSelectedForm[index].viewId).form_mapping.map((path) => {
                if(path.payloadpath) {
                  return (
                    <Option key={path.payloadpath} value={path.payloadpath}>
                      {path.payloadpath}
                    </Option>
                  )
                }
              })}
            </Select>
          </Form.Item>

          <button onClick={() => removePayloadPathInSelectedForm(item.id)}>-</button>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Get Value"
            name={`getvalue${index}`}
            initialValue={item.getvalue || ""}
          >
            <Select showSearch value={item.getvalue} onChange={(value) => handlepayloadPathInSelectedForm(item, value, 'getvalue')}>
              <Option value="" disabled>
                Select
              </Option>
              {
                ['dynamic', 'static'].map((valtype) => {
                  return (
                    <Option key={valtype} value={valtype}>
                      {valtype}
                    </Option>
                  )
                })
              }
            </Select>
          </Form.Item>
          <Form.Item
              label="Value"
              name={`value${index}`}
              initialValue={item.value}
            >
              <Input disabled={item.getvalue != 'static'} onChange={(e) => handlepayloadPathInSelectedForm(item, e.target.value, 'value')} />
            </Form.Item>
        </Col>
        </>
            )
          })
        )}
      </Row>
      <Row gutter={[24, 16]}>
        <Col span={6}>
          <Form.Item label="Color" name="color">
            <button
              className="btn btn-primary"
              onClick={() => setcolorbtn(!colorbtn)}
            >
              {colorbtn ? "Close" : "Pick Color"}
            </button>
            {colorbtn && (
              <ChromePicker
                color={config.color || "#000000"}
                onChangeComplete={(color) =>
                  handleInputChange("color", color.hex)
                }
              />
            )}
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Apply Currency Format"
            name="currencyFormat"
            initialValue={config.currencyFormat || "0"}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Bold Text"
            name="boldText"
            initialValue={config.boldText || "0"}
          >
            <Select>
              <Option value="">
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            label="Add Icon"
            name="addIcon"
            initialValue={config.addIcon || "0"}
          >
            <Select>
              <Option value="" disabled>
                Select
              </Option>
              {yesnoOptions.map(({ option, value }) => (
                <Option key={option} value={value}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {config.addIcon == "1" && (
          <>
            <Col span={3}>
              <Form.Item
                label="Icon Position"
                name="iconPosition"
                initialValue={config.iconPosition}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {iconPosition.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Select Icon"
                name="icontoshow"
                initialValue={config.icontoshow}
              >
                <Select>
                  <Option value="" disabled>
                    Select
                  </Option>
                  {iconList.map(({ option, value }) => (
                    <Option key={option} value={value}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <PEButton
        element_id="createview_delete"
        className="delete_view_field"
        type="primary"
        danger
        onClick={deleteConfig}
      >
        <DeleteFilled />
      </PEButton>
    </Form>
  );
};

function createNestedJson(objectsList) {
  const result = {};
  function getConfigString(obj, value) {
    if (
      (typeof value === "object" && Object.keys(value).length === 0) ||
      value == undefined
    ) {
      value = "[]";
    }
    const config = { ...obj };
    // delete config['BucketField'];

    let x = JSON.parse(value);
    return JSON.stringify([...x, config]);
  }
  objectsList.forEach((obj) => {
    if (!obj.BucketField) {
      return;
    }
    const keys = obj && obj.BucketField && obj.BucketField.split(".");
    let currentLevel = result;

    keys.forEach((key, index) => {
      // console.log(key)
      if (key.includes(":")) {
        const nestedKeys = key.split(":");
        nestedKeys.forEach((currentKey, nestedIndex) => {
          if (nestedIndex === nestedKeys.length - 1) {
            if (index != keys.length - 1) {
              if (!currentLevel[currentKey]) {
                currentLevel[currentKey] = {};
              }
            } else {
              currentLevel[currentKey] = getConfigString(
                obj,
                currentLevel[currentKey]
              );
            }
            currentLevel = currentLevel[currentKey];
          } else {
            currentLevel[currentKey] = currentLevel[currentKey] || [];
            currentLevel = currentLevel[currentKey];
          }
        });
      } else {
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        }

        if (index === keys.length - 1) {
          currentLevel[key] = getConfigString(obj, currentLevel[key]);
        } else {
          currentLevel = currentLevel[key];
        }
      }
    });
  });

  return result;
}

function setLeafNodes(obj, value) {
  for (const key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      setLeafNodes(obj[key], value);
    } else {
      obj[key] = value;
    }
  }
}

function getBucketFieldString(path) {
  return [...path].reverse().reduce((str, value, index) => {
    str += value;
    if (typeof value == "string" && index != path.length - 1) {
      str += ".";
    } else if (typeof value == "number" && index != path.length - 1) {
      str += ":";
    }
    return str;
  }, "");
}

function getObjectPath(bucketField) {
  const _path = bucketField.split(".");
  const path = _path.reduce((pathArr, key) => {
    if (key.includes(":")) {
      key.split(":").forEach((item, index) => {
        if (index == 0) pathArr.push(item);
        else pathArr.push(parseInt(item));
      });
    } else {
      pathArr.push(key);
    }
    return pathArr;
  }, []);
  return path;
}
